import Layout from '../views/layout'
import i18n from '@/lang'
const makerPageRouter = [
  {
    path: 'custom/:customId(\\d+)',
    name: 'template.custom',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
      keys: ['dm'],
      payment: 'free',
    },
  },

  {
    path: 'dco/:customId(\\d+)',
    name: 'template.dco',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
      keys: ['dm'],
      payment: 'free',
    },
  },

  {
    path: 'multi-custom/:customId(\\d+)',
    name: 'template.multi-custom',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
      keys: ['dm'],
      payment: 'free',
    },
  },
]

export default {
  path: '/creative-service',
  component: Layout,
  redirect: 'noredirect',
  name: 'creative-service',
  icon: 'creativity',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.service.name'),
    keys: ['dm'],
    payment: 'free',
  },

  children: [
    {
      path: 'playable/list',
      name: 'creative-service.playable.list',
      component: () =>
        import('@pt/views/creative-service/creative-list/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.service.playable'),
        defaultPath: '/creative-service/playable/list',
        keys: ['dm'],
        payment: 'free',
      },
    },
    {
      path: 'playable/list/:type',
      name: '',
      component: () =>
        import('@pt/views/creative-service/creative-list/index.vue'),
      meta: {
        defaultPath: '/creative-service/playable/list',
        keys: ['dm'],
        payment: 'free',
      },
      hidden: true,
    },
    {
      path: 'playable/:templateId(\\d+)',
      name: 'template.templateId',
      redirect: '/playable/:templateId(\\d+)/version',
      component: {
        template: `<router-view></router-view>`,
      },
      meta: {
        title: i18n.t('playTurbo.versionlist.versionmanage'),
        keys: ['dm'],
        payment: 'free',
      },
      hidden: true,
      children: [
        ...makerPageRouter,
        {
          path: 'version',
          name: 'template.version.list',
          component: () => import('@pt/views/creative-service/version-list'),
          meta: {
            title: i18n.t('playTurbo.versionlist.title'),
            keys: ['dm'],
            payment: 'free',
            defaultPath: '/creative-service/playable/list',
          },
        },
        {
          path: 'version/:type',
          name: 'template.version.list.type',
          component: () => import('@pt/views/creative-service/version-list'),
          meta: {
            title: i18n.t('playTurbo.versionlist.title'),
            keys: ['dm'],
            payment: 'free',
            defaultPath: '/creative-service/playable/list',
          },
        },
      ],
    },
    {
      path: 'pic-video',
      name: 'creative-service.pic-video',
      component: () =>
        import('@pt/views/creative-service/pic-video-list/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.service.image'),
        defaultPath: '/creative-service/pic-video',
        keys: ['dm'],
        payment: 'free',
      },
    },
    {
      path: 'demand-order',
      name: 'creative-service.demand-order',
      component: () =>
        import('@pt/views/creative-service/demand-order-list/index.vue'),
      meta: {
        title: i18n.t('playTurbo.order.3dmodel.title'),
        defaultPath: '/creative-service/demand-order',
        keys: ['dm'],
        payment: 'free',
      },
    },
  ],
}
